<template>
    <v-layout column align-center style="gap: 10px" v-if="isIncoming && value.isGranted === null">
        <grant-respond
            v-bind="{
                value,
                program,
                isGranted: true,
                isUserEmployee,
                isUserEmployer,
            }"
            v-on="{
                input,
            }"
        >
            <template #activator="{ attrs, on }">
                <v-btn small outlined width="73" color="primary" v-bind="attrs" v-on="on">
                    <span>수락</span>
                </v-btn>
            </template>
        </grant-respond>
        <grant-respond
            v-bind="{
                value,
                program,
                isGranted: false,
                isUserEmployee,
                isUserEmployer,
            }"
            v-on="{
                input,
            }"
        >
            <template #activator="{ attrs, on }">
                <v-btn small outlined width="73" color="grey-d" v-bind="attrs" v-on="on">
                    <span class="grey--text">거부</span>
                </v-btn>
            </template>
        </grant-respond>
    </v-layout>
</template>

<script>
import { EXPO_MATCHING_DIRECTIONS } from "@/assets/variables/constants";
import { initExpoMatching, initExpoProgram } from "@/assets/variables/inits";

import GrantRespond from "./grant/grant-respond.vue";

export default {
    components: {
        GrantRespond,
    },
    props: {
        value: { type: Object, default: initExpoMatching },
        program: { type: Object, default: initExpoProgram },
        employee: { type: Object, default: null },
        employer: { type: Object, default: null },
        isUserHost: { type: Boolean, default: false },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },
    },
    computed: {
        isIncoming() {
            if (this.isUserEmployee) {
                return this.value.direction == EXPO_MATCHING_DIRECTIONS.TO_EMPLOYEE.value;
            }
            if (this.isUserEmployer) {
                return this.value.direction == EXPO_MATCHING_DIRECTIONS.TO_EMPLOYER.value;
            }
        },
    },
    methods: {
        input(matching) {
            this.$emit("input", matching);
        },
    },
};
</script>

<style>
</style>